export default {
    'en': 'English',
    'pl': 'Polski',
    'ru': 'Русский',
    'RULES': 'Reguły gry',
    "WORTH": "Warty 2,500 Eur",
    "WIN": "Wygraj",
    "JUSTFIT": "Justfit",
    "ME": "Me",
    "HERO_DESC": "Wygraj pierwszy system EMS, z którego możesz korzystać gdziekolwiek I kiedy chcesz!",
    "SEARCH_JUSTFIT": 'Stoisko Justfit: Hala IV. Stoisko 4.20!',
    "ATTENDANCE": "Aby wziąć udział w grze:",
    "LIST_1": "Odwiedź stoisko Justfit podczas FIWE: Hala IV. Stoisko 4.20",
    "LIST_2": "Zrób selfie przed ścianą ze zdjęciem #winjustfitme",
    "LIST_3": "Prześlij swoje zdjęcie na Instagram lub Facebook z hashtagiem #winjustfitme do północy 15-ego września 2019 r.",
    "SUIT_HEADING": "1 system JustfitMe EMS warty 2,500 Eur",
    "PRIZE": "Nagroda główna:",
    "LIST2_1": "Unisex kombinezon hybrydowy technologiczny JustfitMe – wybierz styl, który lubisz najbardziej",
    "LIST2_2": "Jednostka sterująca JustfitMe",
    "LIST2_3": "Aplikacja mobilna JustfitMe",
    "SECOND_TEXT": "Wygraj pierwszy system EMS (elektrostymulacja mięśni), który może być używany bez ograniczeń w dowolnym miejscu i czasie. Dzięki zaawansowanej technologii elektrostymulacji możesz zachować formę wykonując 2 x 20 minut treningu tygodniowo. I przy okazji, JustfitMe wygląda bardzo fajnie.",
    "SECOND_TEXT_2": "Inne nagrody: 3 koszulki Justfit.",
    "SECOND_TEXT_3": "Nazwiska zwycięzców zostaną opublikowane na naszych stronach na Instagramie i Facebooku. Zwycięscy zostaną także powiadomieni prywatną wiadomością do 22.09.2019. Pomyśl o jutrze, zagraj teraz!",
    "AMAZING_HASHTAG": "#winjustfitme",
}
